// extracted by mini-css-extract-plugin
module.exports = {"flex-input-container":"FlexInput_flex-input-container__bl8JT"};